"use strict";
const options = {
    collectionsLoadMore: '.collections-load-more',
    blsLinkFilter: '.bls__link-filter',
    openFilter: '.filter-title .open-children-toggle',
    rangeSlider: '.price-range .range-slider',
    rangeSliderMin: '.range-slider-min',
    rangeSliderMax: '.range-slider-max',
    gridMode: '.grid-mode-show-type-products .grid-mode',
    viewMode: '.view-mode',
    sidebarClose: '.sidebar-close',
    collectionSidebar: '#CollectionSidebar',
    collectionFiltersForm: '#CollectionFiltersForm',
    btnFilter: '.collection-filter .btn-filter',
    section: '.section-collection-product',
    toolbarSorter: '.toolbar-sorter .select-selected',
    facetFiltersSort: '.facet-filters__sort li',
    overlay: '.bls__overlay',
    filterSortMb: '.toolbar-sorter-mb .facet-filters__label',
    dataSortMb: '.toolbar-sorter-mb__option',
    closeSortMb: '.close-select'
};

var BlsEventCollectionShopify = (function() {
    const marketPriceCache = new Map();
    return {
        init: function() {
            const initialForm = document.querySelector('.filter-form[data-market-rate]');
            const initialQuery = new URLSearchParams(window.location.search);
            if (initialForm && initialForm.dataset.currencyCode !== 'USD' &&
                document.querySelector(options.section)?.dataset.marketPriceResults !== 'true' &&
                (initialQuery.has('filter.v.price.gte') || initialQuery.has('filter.v.price.lte'))) {
                document.querySelector(options.section)?.classList.add('market-price-loading');
            }
            this.setupEventListeners();
            this.eventLoadMore();
            this.ionRangeSlider();
            this.actionDesc();
            this.marketPriceFallback().then(() => this.restoreMarketPriceResults());
        },

        actionDesc: function(){
            const viewMore = document.querySelector('[data-view-more]');
            if (viewMore) {
                viewMore.addEventListener('click', function(e) {
                    const target = e.currentTarget;
                    if (target.closest('.heading-description').classList.contains('show-full-desc')) {
                        target.closest('.heading-description').classList.remove('show-full-desc');
                        target.textContent = target.dataset.readMore
                    } else {
                        target.closest('.heading-description').classList.add('show-full-desc');
                        target.textContent = target.dataset.readLess
                    }
                });
            }
        },

        setupEventListeners: function() {
            document.querySelectorAll('.filter-form').forEach(form => {
                if (!form.querySelector('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"], input[name="filter.p.price.gte"], input[name="filter.p.price.lte"]')) return;
                form.addEventListener('submit', event => {
                    event.preventDefault();
                    const formData = new FormData(form);
                    const priceNames = [
                        'filter.v.price.gte',
                        'filter.v.price.lte',
                        'filter.p.price.gte',
                        'filter.p.price.lte'
                    ];
                    const runtimeRate = Number(window.Shopify?.currency?.rate || 0);
                    const configuredRate = Number(form.dataset.marketRate || 0);
                    const marketRate = runtimeRate > 0 && (runtimeRate !== 1 || form.dataset.currencyCode === 'USD')
                        ? runtimeRate
                        : (configuredRate > 0 ? configuredRate : 1);
                    if (marketRate > 0 && marketRate !== 1) {
                        priceNames.forEach(name => {
                            const value = formData.get(name);
                            if (value !== null && value !== '') {
                                const baseValue = Math.round((Number(value) / marketRate) * 100) / 100;
                                formData.set(name, baseValue.toFixed(2));
                            }
                        });
                    }
                    let queryString = window.location.search;
                    priceNames.forEach(name => {
                        queryString = this.removeParam(name, queryString);
                    });
                    const params = new URLSearchParams(formData).toString();
                    const searchParams = `${queryString.replace('?', '')}${queryString.includes('?') ? '&' : ''}${params}`;
                    const url = this.renderUrl(searchParams);
                    this.renderSectionFilter(url, searchParams, marketRate !== 1);
                }, false);
            });

            document.querySelectorAll(options.btnFilter).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (document.querySelector(options.collectionSidebar).classList.contains('bls__opend-popup')) {
                        target.classList.remove('actived')
                        document.querySelector(options.collectionSidebar).classList.remove('bls__opend-popup');
                        document.querySelector(options.overlay).classList.add('d-none-overlay');
                        document.documentElement.classList.remove('hside_opened');
                        if (target.closest('.collection-filter').classList.contains('dropdonw_sidebar')) {
                            if (window.innerWidth >= 1024) {
                                slideAnime({
                                    target: target.closest('#productgridcontainer').querySelector('#CollectionSidebar'),
                                    animeType: 'slideToggle'
                                });
                            }
                        }
                        target.classList.remove('actived')
                    } else {
                        target.classList.add('actived')
                        document.querySelector(options.collectionSidebar).classList.add('bls__opend-popup');
                        if (!target.closest('.collection-filter').classList.contains('dropdonw_sidebar')) {
                            document.querySelector(options.overlay).classList.remove('d-none-overlay');
                            document.documentElement.classList.add('hside_opened');
                        } else {
                            if (window.innerWidth < 1024) {
                                document.querySelector(options.overlay).classList.remove('d-none-overlay');
                                document.documentElement.classList.add('hside_opened');
                            } else {
                                slideAnime({
                                    target: target.closest('#productgridcontainer').querySelector('#CollectionSidebar'),
                                    animeType: 'slideToggle'
                                });
                            }
                        }
                    }
                }, false);
            });

            document.querySelectorAll(options.openFilter).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    slideAnime({
                        target: target.closest('.filter-item').querySelector('.filter-content'),
                        animeType: 'slideToggle'
                    });
                    if (target.classList.contains('active')) {
                        target.classList.remove('active');
                    } else {
                        target.classList.add('active')
                    }
                }, false);
            });

            document.querySelectorAll(options.sidebarClose).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    document.querySelector(options.collectionSidebar).classList.remove('bls__opend-popup');
                    if (document.querySelector(options.btnFilter)) {
                        document.querySelector(options.btnFilter).classList.remove('actived');
                    }
                    document.querySelector(options.overlay).classList.add('d-none-overlay');
                    document.documentElement.classList.remove('hside_opened');
                }, false);
            });

            document.querySelectorAll(options.viewMode).forEach(view => {
                view.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    const view_mode = target.getAttribute('data-view');
                    if (target.classList.contains('actived')) return;
                    var queryString = window.location.search;
                    queryString = this.removeParam('view', queryString);
                    if (view_mode == 'list') {
                        var searchParams = queryString.replace('?', '')+'&view=list';
                    } else {
                        var searchParams = queryString.replace('?', '')+'&view=grid';
                    }
                    const url = this.renderUrl(searchParams);
                    this.renderSectionFilter(url, searchParams);
                }, false);
            });

            document.querySelectorAll(options.gridMode).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    const view_mode = target.getAttribute('data-grid-mode');
                    if (target.classList.contains('actived')) return;
                    if (view_mode == 1) return;
                    for (var item of document.querySelectorAll(options.gridMode)) {
                        item.classList.remove('actived');
                    }
                    const container_switch = document.querySelector('.container-products-switch');
                    target.classList.add('actived');
                    const data_view_mode = container_switch.getAttribute('data-view-mode');
                    container_switch.classList.remove('grid-columns-'+data_view_mode);
                    container_switch.setAttribute('data-view-mode',view_mode);
                    container_switch.classList.add('grid-columns-'+view_mode);
                }, false);
            });

            document.querySelectorAll(options.blsLinkFilter).forEach(btn => {
                btn.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (target.querySelector('.bls_tooltip')) {
                        target.querySelector('.bls_tooltip').classList.toggle('current-filter');
                    } else {
                        target.closest('li').classList.toggle('current-filter');
                    }
                    const url = target.getAttribute('href');
                    this.renderSectionFilter(url);
                }, false);
            });

            document.body.addEventListener('click', (evt) => {
                const target = evt.target;
                const btn_dropdonw_sidebar = document.querySelector('.collection-filter.dropdonw_sidebar .btn-filter'); 
                if (!target.closest('.select-custom') && target != document.querySelector('.toolbar-sorter .select-custom')) {
                    if (document.querySelector('.toolbar-sorter .select-custom')) {
                        document.querySelector('.toolbar-sorter .select-custom').classList.remove('actived');
                    }
                }
                if (!target.closest('#CollectionSidebar') && target != document.querySelector('#CollectionSidebar') && btn_dropdonw_sidebar && target != btn_dropdonw_sidebar) {
                    if (window.innerWidth >= 1024) {
                        btn_dropdonw_sidebar.classList.remove('actived')
                        document.querySelector(options.collectionSidebar).classList.remove('bls__opend-popup');
                        document.querySelector(options.overlay).classList.add('d-none-overlay');
                        document.documentElement.classList.remove('hside_opened');
                        slideAnime({
                            target: btn_dropdonw_sidebar.closest('#productgridcontainer').querySelector('#CollectionSidebar'),
                            animeType: 'slideUp'
                        });
                    }
                }
            });

            document.querySelectorAll(options.toolbarSorter).forEach(filterSort => {
                filterSort.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (target.closest('.select-custom').classList.contains('actived')) {
                        target.closest('.select-custom').classList.remove('actived');
                    } else {
                        target.closest('.select-custom').classList.add('actived');
                    }
                }, false);
            });
            
            if (document.querySelector(options.filterSortMb)) {
                document.querySelector(options.filterSortMb).addEventListener('click' , event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    if (target.closest('.toolbar-sorter-mb').classList.contains('open-selected')) {
                        target.closest('.toolbar-sorter-mb').classList.remove('open-selected')
                    } else {
                        target.closest('.toolbar-sorter-mb').classList.add('open-selected')
                    }
                }, false);
            }
            
            if (document.querySelector(options.closeSortMb)) {
                document.querySelector(options.closeSortMb).addEventListener('click', event => {
                    event.preventDefault();
                    document.querySelector('.toolbar-sorter-mb').classList.remove('open-selected')
                })
            }

            document.querySelectorAll(options.facetFiltersSort).forEach(filterSort => {
                filterSort.addEventListener("click", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    const value = target.getAttribute('value');
                    var queryString = window.location.search;
                    queryString = this.removeParam('sort_by', queryString);
                    var searchParams = queryString.replace('?', '')+'&sort_by='+value;
                    const url = this.renderUrl(searchParams);
                    this.renderSectionFilter(url, searchParams);
                }, false);
            });
        },

        resolveMarketRate: async function(form, section) {
            const configuredRate = Number(window.Shopify?.currency?.rate || form?.dataset.marketRate || 0);
            if (configuredRate > 0 && (configuredRate !== 1 || form?.dataset.currencyCode === 'USD')) return configuredRate;
            if (!form || !section || form.dataset.currencyCode === 'USD') return 1;
            const parsePrice = value => {
                const match = String(value || '').replace(/\s/g, '').match(/[-+]?\d[\d,]*(?:\.\d+)?/);
                return match ? Number(match[0].replace(/,/g, '')) : 0;
            };
            const currentUrl = new URL(window.location.href);
            ['filter.v.price.gte', 'filter.v.price.lte', 'filter.p.price.gte', 'filter.p.price.lte', 'section_id'].forEach(key => currentUrl.searchParams.delete(key));
            const baseUrl = new URL(currentUrl.href);
            baseUrl.searchParams.delete('country');
            baseUrl.searchParams.delete('currency');
            baseUrl.searchParams.set('country', 'US');
            try {
                const [marketResponse, baseResponse] = await Promise.all([
                    fetch(`${currentUrl.pathname}?${currentUrl.searchParams.toString()}`),
                    fetch(`${baseUrl.pathname}?${baseUrl.searchParams.toString()}`)
                ]);
                if (!marketResponse.ok || !baseResponse.ok) return 1;
                const [marketText, baseText] = await Promise.all([marketResponse.text(), baseResponse.text()]);
                const marketDoc = new DOMParser().parseFromString(marketText, 'text/html');
                const baseDoc = new DOMParser().parseFromString(baseText, 'text/html');
                const marketCards = [...marketDoc.querySelectorAll('[data-product-handle]')];
                const baseCards = [...baseDoc.querySelectorAll('[data-product-handle]')];
                for (const marketCard of marketCards) {
                    const handle = marketCard.dataset.productHandle;
                    const baseCard = baseCards.find(card => card.dataset.productHandle === handle);
                    const marketPrice = parsePrice(marketCard.querySelector('.price__regular, .price')?.textContent);
                    const basePrice = parsePrice(baseCard?.querySelector('.price__regular, .price')?.textContent);
                    if (marketPrice > 0 && basePrice > 0) {
                        const rate = Math.round((marketPrice / basePrice) * 1000000) / 1000000;
                        if (rate > 0) return rate;
                    }
                }
            } catch (error) {
                console.warn('Unable to resolve market currency rate', error);
            }
            return 1;
        },

        marketPriceFallback: async function() {
            const form = document.querySelector('.filter-form[data-market-rate]');
            const priceInput = form?.querySelector('.max-price-range');
            const section = document.querySelector(options.section);
            if (!form || !priceInput || !section) return;
            const marketRate = await this.resolveMarketRate(form, section);
            if (!(marketRate > 0)) return;
            form.dataset.marketRate = String(marketRate);
            // Remove any stale currency decoration left by an older Price input implementation.
            form.querySelectorAll('[data-price-currency], .price-currency-symbol, .currency-symbol').forEach(node => node.remove());
            form.querySelectorAll('.min-price-range, .max-price-range').forEach(input => {
                input.removeAttribute('data-currency-symbol');
                input.removeAttribute('data-currency');
                input.setAttribute('inputmode', 'decimal');
            });
            const query = new URLSearchParams(window.location.search);
            const savedPrice = window.history.state?.selectedMarketPrice;
            const storedPrice = JSON.parse(sessionStorage.getItem(`market-price:${location.pathname}:${query.get('filter.v.price.gte')}:${query.get('filter.v.price.lte')}`) || 'null');
            const selectedPrice = storedPrice?.currency === form.dataset.currencyCode ? storedPrice :
                savedPrice?.currency === form.dataset.currencyCode ? savedPrice : null;
            ['gte', 'lte'].forEach(bound => {
                const input = form.querySelector(`input[name="filter.v.price.${bound}"]`);
                const baseValue = query.get(`filter.v.price.${bound}`);
                if (input && baseValue !== null && baseValue !== '' && Number.isFinite(Number(baseValue))) {
                    const savedValue = bound === 'gte' ? selectedPrice?.min : selectedPrice?.max;
                    const marketValue = savedValue !== undefined ? String(savedValue) : (Number(baseValue) * marketRate).toFixed(2);
                    input.value = marketValue;
                    const slider = form.querySelector(`.range-slider-${bound === 'gte' ? 'min' : 'max'}`);
                    if (slider) {
                        slider.max = String(Math.max(Number(slider.max), Number(marketValue)));
                        slider.value = marketValue;
                    }
                }
            });
            const minDisplay = form.querySelector('.price-lable .min');
            const maxDisplay = form.querySelector('.price-lable .max');
            const updateDisplay = () => {
                const min = Number(form.querySelector('.range-slider-min')?.value || 0);
                const max = Number(form.querySelector('.range-slider-max')?.value || 0);
                const symbol = form.dataset.currencySymbol || '$';
                const locale = form.dataset.currencyCode === 'EUR' ? 'de-DE' : 'en-US';
                const formatMarketPrice = value => `${symbol}${Math.round(value).toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                if (minDisplay) minDisplay.textContent = formatMarketPrice(min);
                if (maxDisplay) maxDisplay.textContent = formatMarketPrice(max);
                const activePrice = section.querySelector('.filter-current [data-filter-type="price_range"] a[href]');
                if (activePrice) activePrice.textContent = `${formatMarketPrice(min)} - ${formatMarketPrice(max)}`;
            };
            updateDisplay();
            if (form.dataset.marketPriceListeners !== 'true') {
                form.querySelectorAll('.range-slider').forEach(slider => slider.addEventListener('input', updateDisplay));
                form.dataset.marketPriceListeners = 'true';
            }
            const url = new URL(window.location.href);
            ['country', 'currency', 'section_id', 'filter.v.price.gte', 'filter.v.price.lte'].forEach(key => url.searchParams.delete(key));
            url.searchParams.set('country', 'US');
            url.searchParams.set('section_id', section.dataset.sectionId);
            fetch(`${url.pathname}?${url.searchParams.toString()}`)
                .then(response => response.ok ? response.text() : '')
                .then(responseText => {
                    if (!responseText) return;
                    const source = new DOMParser().parseFromString(responseText, 'text/html');
                    const sourceInput = source.querySelector('.range-slider-max');
                    const sourceMax = Number(sourceInput?.getAttribute('max') || sourceInput?.value);
                    if (!(sourceMax > 0)) return;
                    const marketMax = Math.round(sourceMax * marketRate * 100) / 100;
                    const sliderMax = form.querySelector('.range-slider-max');
                    const sliderMin = form.querySelector('.range-slider-min');
                    if (sliderMin) sliderMin.max = String(marketMax);
                    if (sliderMax) {
                        sliderMax.max = String(marketMax);
                        const selectedMax = query.get('filter.v.price.lte');
                        sliderMax.value = selectedMax ? String(Math.min(selectedPrice?.max ?? Number(selectedMax) * marketRate, marketMax)) : String(marketMax);
                    }
                    const selectedMin = query.get('filter.v.price.gte');
                    if (sliderMin && selectedMin) sliderMin.value = String(Math.min(selectedPrice?.min ?? Number(selectedMin) * marketRate, marketMax));
                    updateDisplay();
                })
                .catch(() => {});
        },

        restoreMarketPriceResults: function() {
            const section = document.querySelector(options.section);
            const form = section?.querySelector('.filter-form[data-market-rate]');
            const query = new URLSearchParams(window.location.search);
            if (!section || section.dataset.marketPriceResults === 'true' || !form || form.dataset.currencyCode === 'USD') return;
            if (!query.has('filter.v.price.gte') && !query.has('filter.v.price.lte')) return;
            const sectionUrl = this.renderUrl(query.toString());
            this.renderSectionFilter(sectionUrl, query.toString(), true, true);
        },

        ionRangeSlider: function() {
            const price_range = document.querySelector('.price-range');
            const maxRange = document.querySelector(options.rangeSliderMax);
            const minRange = document.querySelector(options.rangeSliderMin);
            const minPrice = document.querySelector('.min-price-range');
            const maxPrice = document.querySelector('.max-price-range');
            var minPriceRange = 0;
            var maxPriceRange = 0;
            // The CAD fallback uses text inputs without the native range slider.
            // Stop here so its later initialization can still run.
            if (!price_range || !maxRange || !minRange || !minPrice || !maxPrice) return;
            document.querySelector(options.rangeSliderMin).addEventListener("input", event => {
                event.preventDefault();
                const target = event.currentTarget;
                if (Number(maxRange.value) - Number(target.value) >= 1) {
                    minPrice.value = Number(target.value);
                    minPriceRange = Number(target.value) * 100;
                } else {
                    target.value = Number(maxRange.value) - 1;
                    minPriceRange = (Number(maxRange.value) - 1)*100;
                }
                const price_format = Shopify.formatMoney(minPriceRange, cartStrings.money_format);
                document.querySelector('.price-lable .min').innerHTML = price_format;
                target.closest(".price-range").style.setProperty('--range-from', minRange.value / Number(target.getAttribute('max')) * 100 + '%');
            }, false);
            document.querySelector(options.rangeSliderMax).addEventListener("input", event => {
                event.preventDefault();
                const target = event.currentTarget;
                if (target.value - minRange.value >= 1) {
                    maxPrice.value = target.value;
                    maxPriceRange = Number(target.value) * 100;
                } else {
                    target.value = Number(minRange.value) + Number(1);
                    maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
                }
                const price_format = Shopify.formatMoney(maxPriceRange, cartStrings.money_format);
                document.querySelector('.price-lable .max').innerHTML = price_format;
                target.closest(".price-range").style.setProperty('--range-to', maxRange.value / Number(target.getAttribute('max')) * 100 + '%');
            }, false);
            document.querySelectorAll(options.rangeSlider).forEach(sliderRange => {
                sliderRange.addEventListener("change", event => {
                    event.preventDefault();
                    const target = event.currentTarget;
                    const formData = new FormData(document.querySelector(options.collectionFiltersForm));
                    // Shopify's collection price filter expects the shop currency,
                    // while the inputs are rendered in the active market currency.
                    const activeForm = document.querySelector('.filter-form[data-market-rate]');
                    const runtimeRate = Number(window.Shopify?.currency?.rate || 0);
                    const configuredRate = Number(activeForm?.dataset.marketRate || 0);
                    const marketRate = runtimeRate > 0 && (runtimeRate !== 1 || activeForm?.dataset.currencyCode === 'USD')
                        ? runtimeRate
                        : (configuredRate > 0 ? configuredRate : 1);
                    if (marketRate > 0 && marketRate !== 1) {
                        [minPrice.name, maxPrice.name].forEach(name => {
                            const value = formData.get(name);
                            if (value !== null && value !== '') {
                                const baseValue = Math.round((Number(value) / marketRate) * 100) / 100;
                                formData.set(name, baseValue.toFixed(2));
                            }
                        });
                    }
                    const params = new URLSearchParams(formData).toString();
                    const nameMin = minPrice.getAttribute('name');
                    const nameMax = maxPrice.getAttribute('name');
                    var queryString = window.location.search;
                    queryString = this.removeParam(nameMin, queryString);
                    queryString = this.removeParam(nameMax, queryString);
                    var searchParams = queryString.replace('?', '')+'&'+params;
                    const url = this.renderUrl(searchParams);
                    if (marketRate !== 1) {
                        sessionStorage.setItem(`market-price:${location.pathname}:${new URLSearchParams(searchParams).get('filter.v.price.gte')}:${new URLSearchParams(searchParams).get('filter.v.price.lte')}`,
                            JSON.stringify({ min: Number(minRange.value), max: Number(maxRange.value), currency: document.querySelector('.filter-form')?.dataset.currencyCode }));
                    }
                    this.renderSectionFilter(url, searchParams, marketRate !== 1);
                    window.history.replaceState({
                        ...window.history.state,
                        selectedMarketPrice: {
                            min: Number(minRange.value),
                            max: Number(maxRange.value),
                            currency: document.querySelector('.filter-form')?.dataset.currencyCode
                        }
                    }, '', window.location.href);
                }, false);
            });
        },

        removeParam: function(key, sourceURL) {
            var rtn = sourceURL.split("?")[0],
                param,
                params_arr = [],
                queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
            if (queryString !== "") {
                params_arr = queryString.split("&");
                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                    param = params_arr[i].split("=")[0];
                    if (param === key) {
                        params_arr.splice(i, 1);
                    }
                }
                if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
            }
            return rtn;
        },

        renderUrl: function(searchParams) {
            const sectionId = document.querySelector(options.section).dataset.sectionId;
            const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
            return url;
        },

        renderSectionFilter: function(url, searchParams, fetchBaseCurrency = false, restoring = false) {
            this.toggleLoading(document.body, true);
            const currentSection = document.querySelector(options.section);
            const currentForm = currentSection?.querySelector('.filter-form[data-market-rate]');
            const expandedFilterLabels = currentSection
                ? [...currentSection.querySelectorAll('.filter-item')]
                    .filter(item => {
                        const content = item.querySelector('.filter-content');
                        const toggle = item.querySelector('.open-children-toggle');
                        return toggle?.classList.contains('active') || (content && getComputedStyle(content).display !== 'none');
                    })
                    .map(item => item.querySelector('.filter-title')?.childNodes[0]?.textContent.trim())
                    .filter(Boolean)
                : [];
            const priceQuery = new URLSearchParams(searchParams);
            const useBaseCurrency = fetchBaseCurrency || (currentForm && currentForm.dataset.currencyCode !== 'USD' &&
                (priceQuery.has('filter.v.price.gte') || priceQuery.has('filter.v.price.lte')));
            if (useBaseCurrency && currentSection) {
                currentSection.querySelectorAll('[data-product-handle]').forEach(card => {
                    const handle = card.dataset.productHandle;
                    const price = card.querySelector('.bls__product-price');
                    if (handle && price) marketPriceCache.set(handle, price.innerHTML);
                });
            }
            const requestUrl = useBaseCurrency ? (() => {
                const parsed = new URL(url, window.location.origin);
                parsed.searchParams.delete('country');
                parsed.searchParams.delete('currency');
                parsed.searchParams.set('country', 'US');
                return `${parsed.pathname}?${parsed.searchParams.toString()}`;
            })() : (() => {
                const parsed = new URL(url, window.location.origin);
                const activeForm = document.querySelector('.filter-form[data-market-rate]');
                const countryCode = activeForm?.dataset.countryCode;
                const currencyCode = activeForm?.dataset.currencyCode;
                if (countryCode && currencyCode && currencyCode !== 'USD' && !parsed.searchParams.has('country')) {
                    parsed.searchParams.set('country', countryCode);
                }
                return `${parsed.pathname}?${parsed.searchParams.toString()}`;
            })();
            fetch(`${requestUrl}`)
                .then((response) => {
                    if (!response.ok) {
                    var error = new Error(response.status);
                    throw error;
                    }
                    return response.text();
                })
                .then(async responseText => {
                    const newSection = new DOMParser().parseFromString(responseText, 'text/html').querySelector(options.section);
                    if (!newSection) throw new Error('Collection section was not returned');
                    if (useBaseCurrency) {
                        newSection.dataset.marketPriceResults = 'true';
                        const currentForm = document.querySelector('.filter-form[data-market-rate]');
                        const newForm = newSection.querySelector('.filter-form[data-market-rate]');
                        if (currentForm && newForm) {
                            newForm.dataset.countryCode = currentForm.dataset.countryCode;
                            newForm.dataset.currencyCode = currentForm.dataset.currencyCode;
                            newForm.dataset.currencySymbol = currentForm.dataset.currencySymbol;
                        }
                    }
                    if (useBaseCurrency) {
                        const missing = [...newSection.querySelectorAll('[data-product-handle]')]
                            .map(card => card.dataset.productHandle)
                            .filter(handle => handle && !marketPriceCache.has(handle));
                        if (missing.length) await this.loadMarketPrices(missing, searchParams);
                        // The US fragment is used only for Shopify's reliable price filtering.
                        // Restore the market-rendered price HTML captured before replacement so
                        // rounding, compare-at prices, and market-specific formatting stay intact.
                        newSection.querySelectorAll('[data-product-handle]').forEach(card => {
                            const cachedPrice = marketPriceCache.get(card.dataset.productHandle);
                            const price = card.querySelector('.bls__product-price');
                            if (price) price.innerHTML = cachedPrice || '';
                        });
                        const currentForm = document.querySelector('.filter-form[data-market-rate]');
                        const currencyCode = currentForm?.dataset.currencyCode;
                        if (currencyCode && currencyCode !== 'USD') {
                            const params = new URLSearchParams(searchParams);
                            const stored = JSON.parse(sessionStorage.getItem(`market-price:${location.pathname}:${params.get('filter.v.price.gte')}:${params.get('filter.v.price.lte')}`) || 'null');
                            const selected = stored?.currency === currencyCode ? stored :
                                window.history.state?.selectedMarketPrice?.currency === currencyCode ? window.history.state.selectedMarketPrice : null;
                            const runtimeRate = Number(window.Shopify?.currency?.rate || 0);
                            const configuredRate = Number(currentForm.dataset.marketRate || 0);
                            const rate = runtimeRate > 0 && (runtimeRate !== 1 || currencyCode === 'USD')
                                ? runtimeRate
                                : (configuredRate > 0 ? configuredRate : 1);
                            const min = selected?.currency === currencyCode ? Number(selected.min || 0) : Number(new URLSearchParams(searchParams).get('filter.v.price.gte') || 0) * rate;
                            const maxParam = new URLSearchParams(searchParams).get('filter.v.price.lte');
                            const max = selected?.currency === currencyCode ? Number(selected.max) : (maxParam ? Number(maxParam) * rate : null);
                            const activePrice = newSection.querySelector('.filter-current [data-filter-type="price_range"] a[href]');
                            if (activePrice && max !== null && Number.isFinite(max)) {
                                const symbol = currentForm.dataset.currencySymbol || '$';
                                const locale = currencyCode === 'EUR' ? 'de-DE' : 'en-US';
                                const fmt = value => `${symbol}${Math.round(Number(value)).toLocaleString(locale, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                                activePrice.textContent = `${fmt(min)} - ${fmt(max)}`;
                            }
                        }
                    }
                    document.querySelector(options.section).replaceWith(newSection);
                    if (expandedFilterLabels.length) {
                        document.querySelectorAll(`${options.section} .filter-item`).forEach(item => {
                            const label = item.querySelector('.filter-title')?.childNodes[0]?.textContent.trim();
                            if (!expandedFilterLabels.includes(label)) return;
                            const content = item.querySelector('.filter-content');
                            const toggle = item.querySelector('.open-children-toggle');
                            if (content) content.style.display = 'block';
                            if (toggle) toggle.classList.add('active');
                        });
                    }
                    if (useBaseCurrency) this.marketPriceFallback();
                    document.querySelector(options.overlay).classList.add('d-none-overlay');
                    document.documentElement.classList.remove('hside_opened');
                    this.toggleLoading(document.body, false);
                })
                .catch((error) => {
                    console.error('Unable to update collection price filter', error);
                })
                .finally(() => {
                    document.documentElement.classList.remove('market-price-initializing');
                    document.querySelector(options.section)?.classList.remove('market-price-loading');
                    BlsReloadSpr.init();
                    BlsEventCollectionShopify.init();
                    BlsColorSwatchesShopify.init();
                    BlsSubActionProduct.init();
                    setTimeout(function() {
                        BlsLazyloadImg.init();
                    }, 200);
                });
            if (!restoring) {
                const activeForm = document.querySelector('.filter-form[data-market-rate]');
                const historyQuery = new URLSearchParams(searchParams || new URL(url, window.location.origin).search);
                if (activeForm?.dataset.currencyCode !== 'USD' && activeForm?.dataset.countryCode && !historyQuery.has('country')) {
                    historyQuery.set('country', activeForm.dataset.countryCode);
                }
                const historyParams = historyQuery.toString();
                this.updateUrl(url, historyParams);
            }
        },

        loadMarketPrices: async function(handles, searchParams) {
            const missing = new Set(handles);
            const sectionId = document.querySelector(options.section)?.dataset.sectionId;
            const params = new URLSearchParams(searchParams);
            ['country', 'currency', 'filter.v.price.gte', 'filter.v.price.lte', 'section_id', 'page'].forEach(key => params.delete(key));
            const currentForm = document.querySelector('.filter-form[data-market-rate]');
            const activeCountry = currentForm?.dataset.countryCode || new URLSearchParams(window.location.search).get('country');
            params.set('country', activeCountry || 'US');
            params.set('section_id', sectionId);
            const readPage = async page => {
                params.set('page', String(page));
                const response = await fetch(`${window.location.pathname}?${params.toString()}`);
                if (response.status === 404) return new DOMParser().parseFromString('', 'text/html');
                if (!response.ok) throw new Error(`Market price page ${page} failed`);
                const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
                doc.querySelectorAll('[data-product-handle]').forEach(card => {
                    const handle = card.dataset.productHandle;
                    const price = card.querySelector('.bls__product-price');
                    if (handle && price) {
                        marketPriceCache.set(handle, price.innerHTML);
                        missing.delete(handle);
                    }
                });
                return doc;
            };
            for (let page = 1; page <= 30 && missing.size; page += 3) {
                const docs = await Promise.all([page, page + 1, page + 2].map(readPage));
                if (docs.some(doc => !doc.querySelector('[data-product-handle]'))) break;
            }
            if (missing.size) throw new Error(`Market prices unavailable for ${missing.size} products`);
        },

        eventLoadMore: function() {
            document.querySelectorAll(options.collectionsLoadMore).forEach(loadMore => {
                var _this = this;
                if (loadMore.classList.contains('infinit-scrolling')) {
                    var observer = new IntersectionObserver(function (entries) {
                        entries.forEach(entry => {
                            entries.forEach(entry => {
                                if (entry.intersectionRatio === 1){
                                    _this.loadMoreProducts(loadMore);
                                }
                            });
                        });
                    }, {threshold: 1.0});
                    observer.observe(loadMore);
                } else {
                    loadMore.addEventListener("click", event => {
                        event.preventDefault();
                        const target = event.currentTarget;
                        _this.loadMoreProducts(target);
                    }, false);
                }
            });
        },

        loadMoreProducts: function(target) {
            const loadMore_url = target.getAttribute('href');
            this.toggleLoading(target, true);
            fetch(`${loadMore_url}`)
                .then((response) => {
                    if (!response.ok) {
                    var error = new Error(response.status);
                    throw error;
                    }
                    return response.text();
                })
                .then(responseText => {
                    const productNodes = parser.parseFromString(responseText, 'text/html');
                    const productNodesHtml = productNodes.querySelectorAll('#bls__product-grid .bls__grid__item');
                    productNodesHtml.forEach(prodNode => document.getElementById("bls__product-grid").appendChild(prodNode));
                    const load_more = productNodes.querySelector('.collections-load-more');
                    document.querySelector(".load-more-amount").innerHTML = productNodes.querySelector('.load-more-amount').textContent;
                    document.querySelector(".load-more-percent").style.width = productNodes.querySelector('.load-more-percent').style.width;
                    if ( load_more ) {
                        target.setAttribute("href", load_more.getAttribute('href'));
                    } else {
                        target.remove();
                    }
                    this.toggleLoading(target, false);
                })
                .catch((error) => {
                    throw error;
                })
                .finally(() => {
                    BlsColorSwatchesShopify.init();
                    BlsSubActionProduct.init();
                    BlsReloadSpr.init();
                    setTimeout(function() {
                        BlsLazyloadImg.init();
                    }, 200);
                    
                });
        },

        toggleLoading: function(event, loading) {
            if (event) {
                if (loading) {
                  event.classList.add('start', 'loading');
                } else {
                  event.classList.add('finish');
                  setTimeout(function() {
                    event.classList.remove('start', 'loading', 'finish');
                  }, 500)
                }
            }
        },

        updateUrl: function(url, searchParams = false) {
            if (searchParams) {
                const urlUpdate = `${window.location.pathname}?${searchParams}`;
                window.history.pushState({url: urlUpdate}, '', urlUpdate);
            } else {
                window.history.pushState({url: url}, '', url);
            }
        }
    }
})();
BlsEventCollectionShopify.init();
